import './styles.scss';

import React, {CSSProperties, PropsWithChildren, ReactNode, useMemo} from 'react';

export enum AppTooltipMode {
    INFO = 'app-tooltip_icon-info',
    QUESTION = 'app-tooltip_icon-question',
}

interface AppTooltipProps extends PropsWithChildren {
    mode?: AppTooltipMode;
    style?: CSSProperties;
    TooltipContent?: ReactNode;
    onClick?: () => void;
}

export const AppTooltip = ({
    mode = AppTooltipMode.INFO,
    style,
    children,
    TooltipContent,
    onClick,
}: AppTooltipProps) => {
    const className = useMemo(() => {
        const isClickable = onClick ? 'app-tooltip_clickable' : '';

        return `app-tooltip ${isClickable} ${mode}`;
    }, [onClick, mode]);
    return (
        <div style={style} className={className} onClick={onClick}>
            <span className='app-tooltip__content'>{children}</span>
            {TooltipContent && <div className='app-tooltip__text'>{TooltipContent}</div>}
        </div>
    );
};
